import styled from "styled-components/macro";

const CTAButton = styled.button`
  padding: 0 16px;
  background-color: ${({ theme }) => theme.primary};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
  border-radius: 100px;
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.primaryActive};
  }
`;

export default CTAButton;
